import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { NavigateNext as NavigateNextIcon } from "@mui/icons-material";
import type { SxProps, Theme } from "@mui/material/styles";

export const useStepBreadcrumbsStyles = (): Record<string, SxProps<Theme>> =>
  React.useMemo(
    () => ({
      breadcrumbLink: {
        cursor: "pointer",
      },
      underline: {
        textDecoration: "underline",
      },
      disabledBreadcrumb: {
        pointerEvents: "none",
        color: "text.disabled",
        cursor: "default",
      },
    }),
    [],
  );

type StepBreadcrumbsProps = {
  steps: string[];
  currentStepIndex: number;
  onClick: (index: number) => void;
}

const BreadcrumbLinkItem: React.FC<{
  step: string;
  index: number;
  currentStepIndex: number;
  onClick: (index: number) => void;
  classes: ReturnType<typeof useStepBreadcrumbsStyles>;
}> = ({ step, index, currentStepIndex, onClick, classes }) => {
  if (index === currentStepIndex) {
    return (
      <Typography color="primary" sx={classes.underline}>
        {step}
      </Typography>
    );
  }
  const linkSx = index < currentStepIndex ? classes.breadcrumbLink : classes.disabledBreadcrumb;
  return (
    <Link color="inherit" onClick={() => onClick(index)} sx={linkSx}>
      {step}
    </Link>
  );
};

export const StepBreadcrumbs: React.FC<StepBreadcrumbsProps> = (props) => {
  const classes = useStepBreadcrumbsStyles();
  const { steps, currentStepIndex, onClick } = props;

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      {steps.map((step, index) => (
        <BreadcrumbLinkItem
          key={step}
          step={step}
          index={index}
          currentStepIndex={currentStepIndex}
          onClick={onClick}
          classes={classes}
        />
      ))}
    </Breadcrumbs>
  );
};

export default StepBreadcrumbs;


